<template>
  <div>
    <PageName title="Пассажир" :buttons="buttons" />
    <Preloader v-if="passengerLoading" />
    <Profile v-else :user="passenger" :info="userInfo" />
  </div>
</template>

<script>
import PageName from "@/components/PageName.vue";
import Profile from "@/components/Profile.vue";
import Preloader from "@/components/Preloader.vue";
import { getPassenger, deletePassenger } from "@/api/passengers";
// import { phone } from "@/utils/filters/formatFilters";
import { mapActions, mapGetters } from "vuex";
import { simpleDate } from "@/utils/filters/dateFilters";

export default {
  components: {
    Profile,
    PageName,
    Preloader,
  },
  mounted() {
    getPassenger(this.$route.params.id)
      .then(({ data }) => (this.passenger = data))
      .finally(() => (this.passengerLoading = false));
  },
  data() {
    return {
      buttons: [
        {
          text: "Редактировать",
          icon: "edit",
          event: () => !this.passengerLoading && this.toEdit(),
          iconWidth: "16px",
        },
        {
          text: "Удалить",
          icon: "delete",
          event: () => !this.passengerLoading && this.deletePassenger(),
          iconWidth: "12px",
        },
      ],
      passenger: {},
      passengerLoading: true,
    };
  },
  computed: {
    ...mapGetters("departments", ["getDepartmentById"]),
    userInfo() {
      return [
        {
          title: "Дата рождения:",
          text: this.passenger.birthday
            ? simpleDate(this.passenger.birthday)
            : "-",
        },
        {
          title: "Пол",
          text:
            typeof this.passenger.sex === "boolean"
              ? this.passenger.sex
                ? "Мужской"
                : "Женский"
              : "-",
        },
        {
          title: "Телефон",
          text: this.passenger.phone ? this.passenger.phone : "-",
        },
        {
          title: "Тип документа",
          text: this.passenger.document?.name || "-",
        },
        {
          title: "Номер документа",
          text: this.passenger.document_number || "-",
        },
        {
          title: "Срок действия документа",
          text: this.passenger.document_validity
            ? simpleDate(this.passenger.document_validity)
            : "-",
        },        
        {
          title: "Гражданство",
          text: this.passenger.citizenship || "-",
        },
        {
          title: "Филиал",
          text: this.passenger.filiation?.name || "-",
        },
        {
          title: "Подразделение",
          text: this.department || "-",
          type: 'department'
        },
        {
          title: "VIP",
          text:  this.passenger.is_vip ? 'Да' : "Нет",
        },
      ];
    },
    department() {
      return this.getDepartmentById(this.passenger?.department?.id);
    },
  },
  methods: {
    ...mapActions("users", ["getPassengers"]),
    deletePassenger() {
      const deleteUserFunc = () =>
        deletePassenger(this.$route.params.id).then(() => {
          this.getPassengers();
          this.$router.push({ name: "Passengers" });
        });

      this.$root.confrim(
        "Вы точно хотите удалить этого пассажира?",
        deleteUserFunc,
        "Да"
      );
    },
    toEdit() {
      this.$router.push({
        name: "SavePassenger",
        params: { passenger: this.passenger },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
